var map = {
	"./aurora.png": 54287,
	"./half-vector.png": 95847,
	"./lightning-icon.png": 71924,
	"./pentagon-icon.png": 50776,
	"./rhomb-icon.png": 73118,
	"./star-icon.png": 81840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57403;